<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="8" sm="10">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.pendingShipments') }}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <shipments-wrapper :pendings="true"></shipments-wrapper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ShipmentsWrapper from '../../components/EDI/shipments/ShipmentsWrapper'

export default {
  name: 'PendingShipmentsPage',
  components: { ShipmentsWrapper }
}
</script>

<style>

</style>
